// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__TPJps","l21":"Loader_l21__2hEw8","loaderContainer":"Loader_loaderContainer__bmFRA"};